import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { DialogTitle } from '../../../components/DialogTitle';
import { RxOptions } from './RxOptions';

SelectRxDialog.propTypes = {
  saveSelection: PropTypes.func.isRequired,
  cancelSelection: PropTypes.func.isRequired,
};

export function SelectRxDialog(props) {
  const { saveSelection, cancelSelection, title, selectedOption } = props;
  const [options, setOptions] = useState();

  return (
    <Dialog keepMounted open maxWidth="sm">
      <Box sx={{ backgroundColor: 'primary.main', height: 10 }}></Box>
      <DialogTitle onClose={cancelSelection} title={title} />
      <DialogContent>
        <RxOptions setOptions={setOptions} selectedOption={selectedOption} />
      </DialogContent>
      <DialogActions sx={{ px: 4, py: 4 }}>
        <Button
          onClick={(event) => {
            event.stopPropagation();
            cancelSelection();
          }}
          data-testid={'cancel-selection'}
          variant="contained"
          color="dark"
          sx={{ mr: 1 }}
        >
          Cancel
        </Button>
        <Button
          disabled={!options?.elements?.length}
          onClick={(event) => {
            event.stopPropagation();
            saveSelection(options.elements);
          }}
          data-testid={'save-selection'}
          variant="contained"
          color="primary"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
